import type { FC } from "react";
import styled from "@emotion/styled";
import { Globe } from "lucide-react";
import { colors, fonts, spacing } from "../design-tokens";
import { ActionButton } from "../primitives/action-button";
import type { SourceUrlUIPart } from "ai";

const SourcesButtonContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.xs}px;
  color: ${colors.text};
  ${fonts.bodyFont}
  font-size: 14px;
  font-weight: 400;
`;

type SourcesButtonProps = {
  sources: SourceUrlUIPart[];
  onSourcesClick: () => void;
};

export const SourcesButton: FC<SourcesButtonProps> = ({
  sources,
  onSourcesClick,
}) => {
  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <ActionButton onClick={onSourcesClick} aria-label="View sources" variant="ghost" size="small">
      <SourcesButtonContainer>
        <Globe size={16} />
        <span>{`Sources (${sources.length})`}</span>
      </SourcesButtonContainer>
    </ActionButton>
  );
};
